<template>
    <div class="row">
        <div class="col-12">
            <h2>{{ technicalSheetDto.title }}</h2>
        </div>

        <!--/* Contenu du pack */-->
        <div v-if="technicalSheetDto.packContentDTO" class="col-12">
            <p class="lead mb-0">
                <strong>{{ technicalSheetDto.packContentDTO.title }}</strong>
            </p>
            <p class="mb-0" v-html="technicalSheetDto.packContentDTO.text" />
        </div>

        <!--/* Caractéristiques */-->
        <div class="col-12 d-md-block">
            <div class="row">
                <div
                    v-for="(characteristicDto, characteristicIndex) in characteristics"
                    :key="characteristicIndex"
                    class="col-12 col-md-6 py-1"
                >
                    <p class="lead mb-0">
                        <strong>{{ characteristicDto.title }}</strong>
                    </p>
                    <div v-for="(characteristicDetailsDto, index) in characteristicDto.characteristicsDetailsDTO" :key="index">
                        <div class="d-flex" :class="{'bg-gray2':index % 2 !== 0}">
                            <div class="col-6 characteristic__details">
                                <span>{{ characteristicDetailsDto.title }}</span>
                            </div>
                            <div class="col-6 characteristic__details">
                                <span>{{ characteristicDetailsDto.text }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "TechnicalSheet",
    props: {
        technicalSheetDto: {
            type: Object,
            required: true
        },
        refurbishedCharacteristicDto: {
            type: Object,
            required: false,
            default: undefined
        }
    },
    computed: {
        characteristics: function() {
            // On ne rajoute refurbishedCharacteristicDto que si !undefined
            let result = Array.from(this.technicalSheetDto.characteristicsDTO)
            result.push(this.refurbishedCharacteristicDto)
            return result.filter(x => x !== undefined);
        }
    }
}
</script>

<style lang="scss">
@import 'ob1_common';

.characteristic__details {
    margin-top: px-to-rem(5);
    margin-bottom: px-to-rem(5);
    overflow-wrap: break-word;
}

</style>
